export default {
  "fontSize": 13,
  h1: {
    fontWeight: 300,
    fontSize: 32,
    letterSpacing: '-0.24px'
  },
  h2: {
    fontWeight: 300,
    fontSize: 27,
    letterSpacing: '-0.24px'
  },
  h3: {
    fontWeight: 300,
    fontSize: 22,
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 300,
    fontSize: 18,
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 300,
    fontSize: 14,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 300,
    fontSize: 12,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 300,
    foreColor: '#FF0000'
  }
};
